await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/item-selector-taglib/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import PropTypes from 'prop-types';
import React from 'react';

const PreviewVideo = ({html}) => (
	<div
		className="video-preview"
		dangerouslySetInnerHTML={{
			__html: html,
		}}
	></div>
);

PreviewVideo.propTypes = {
	html: PropTypes.string.isRequired,
};

export default PreviewVideo;
